import { useLocation } from "react-router-dom";
import { delegateStepsIcon } from "../utils/constants";

export default function Steps({
  isAuthenticated,
  isUnStakeAmountConfirmed,
  isStakeAmountConfirmed,
  isTermsAgreed,
  isUnstake,
}) {
  const {pathname} = useLocation();
  return (
    <div className="relative steps pb-10 md:pb-[90px]">
      {!isUnstake && (
        <ul className="flex items-center justify-start gap-3 laptop:gap-[14px] w-full overflow-x-auto overflow-y-hidden *:pb-4 *:relative">
          <li className="cursor-auto">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div className="w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full *:w-full *:h-full p-[10px] lg:p-[13px] icon !bg-green/[.14] !text-green">
                {delegateStepsIcon.connectWallet}
              </div>

              <div
                className={`relative progress h-[1px] bg-white/[.12] ${isAuthenticated ? "" : "before:w-1/2"
                  }`}
              ></div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isAuthenticated
                  ? "text-green"
                  : "text-dim"
                  }`}
              >
                Step 01
              </h5>
              <p className="text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize text-dim/30 whitespace-nowrap !text-dim">
                Connect Wallet
              </p>
            </div>
          </li>

          <li className="cursor-progress">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div
                className={`w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-[#D9D9D9]/[.14] text-[#fff5f5]/[.17] *:w-full *:h-full p-[10px] lg:p-[13px] icon ${isAuthenticated
                  ? "!bg-green/[.14] !text-green"
                  : ""
                  }`}
              >
                {delegateStepsIcon.enterStake}
              </div>

              <div
                className={`relative progress h-[1px] bg-white/[.12] ${isStakeAmountConfirmed ? "" : "before:w-1/2"
                  } ${isAuthenticated ? "" : "before:hidden"}`}
              ></div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize
                  ${isAuthenticated
                    ? "!text-green"
                    : "!text-dim/30"
                  }`}
              >
                Step 02
              </h5>
              <p
                className={`text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize whitespace-nowrap ${isAuthenticated
                  ? "!text-dim"
                  : "!text-dim/30"
                  }`}
              >
                Enter Stake Amount
              </p>
            </div>
          </li>

          {/* <li className="cursor-not-allowed">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div
                className={`w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-[#D9D9D9]/[.14] text-[#fff5f5]/[.17] *:w-full *:h-full p-[10px] lg:p-[13px] icon ${isAuthenticated && isStakeAmountConfirmed
                  ? "!bg-green/[.14] !text-green"
                  : ""
                  } `}
              >
                {delegateStepsIcon.terms}
              </div>

              <div
                className={`relative progress h-[1px] bg-white/[.12] ${isTermsAgreed ? "" : "before:w-1/2"
                  } ${isAuthenticated && isStakeAmountConfirmed
                    ? ""
                    : "before:hidden"
                  }`}
              ></div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isAuthenticated && isStakeAmountConfirmed
                  ? "!text-green"
                  : "!text-dim/30"
                  }`}
              >
                Step 03
              </h5>
              <p
                className={`text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize text-dim/30 whitespace-nowrap ${isAuthenticated && isStakeAmountConfirmed
                  ? "!text-dim"
                  : "!text-dim/30"
                  }`}
              >
                Read and Agree to Terms & Conditions
              </p>
            </div>
          </li> */}

          <li className="cursor-not-allowed">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div
                className={`w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-[#D9D9D9]/[.14] text-[#fff5f5]/[.17] *:w-full *:h-full p-[10px] lg:p-[13px] icon ${isStakeAmountConfirmed && isTermsAgreed
                    ? "!bg-green/[.14] !text-green"
                    : ""
                  } `}
              >
                {delegateStepsIcon.confirm}
              </div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isStakeAmountConfirmed && isTermsAgreed
                    ? "!text-green"
                    : "!text-dim/30"
                  }`}
              >
                Step 03
              </h5>
              <p
                className={`text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize whitespace-nowrap ${isStakeAmountConfirmed && isTermsAgreed
                    ? "!text-dim"
                    : "!text-dim/30"
                  }`}
              >
                Review and Confirm Stake
              </p>
            </div>
          </li>
        </ul>
      )}
      {isUnstake && (
        <ul className="flex items-center justify-start gap-3 laptop:gap-[14px] w-full overflow-x-auto overflow-y-hidden *:pb-4 *:relative">
          <li className="cursor-auto">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div className="w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full *:w-full *:h-full p-[10px] lg:p-[13px] icon !bg-green/[.14] !text-green">
                {delegateStepsIcon.connectWallet}
              </div>

              <div
                className={`relative progress h-[1px] bg-white/[.12] ${isUnStakeAmountConfirmed ? "" : "before:w-1/2"
                  }`}
              ></div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isAuthenticated
                  ? "text-green"
                  : "text-dim/30"
                  }`}
              >
                Step 01
              </h5>
              <p className="text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize text-dim/30 whitespace-nowrap !text-dim">
                {pathname?.includes("claim") ? "Verify Your Unstake Claim" :"Enter Amount to Unstake" }
              </p>
            </div>
          </li>

          {/* <li className="cursor-progress">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div
                className={`w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-[#D9D9D9]/[.14] text-[#fff5f5]/[.17] *:w-full *:h-full p-[10px] lg:p-[13px] icon ${isUnStakeAmountConfirmed
                  ? "!bg-green/[.14] !text-green"
                  : ""
                  }`}
              >
                {delegateStepsIcon.connectWallet}
              </div>

              <div
                className={`relative progress h-[1px] bg-white/[.12] ${isTermsAgreed ? "" : "before:w-1/2"
                  } ${isUnStakeAmountConfirmed ? "" : "before:hidden"}`}
              ></div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isUnStakeAmountConfirmed
                  ? "!text-green"
                  : "!text-dim/30"
                  }`}
              >
                Step 02
              </h5>
              <p
                className={`text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize whitespace-nowrap ${isUnStakeAmountConfirmed
                  ? "!text-dim"
                  : "!text-dim/30"
                  }`}
              >
                Read and Agree to Terms & Conditions
              </p>
            </div>
          </li> */}

          <li className="cursor-not-allowed">
            <div className="flex items-center gap-4 mb-[23px] lg:mb-[25px]">
              <div
                className={`w-[32px] h-[32px] lg:w-12 lg:h-12 flex items-center justify-center rounded-full bg-[#D9D9D9]/[.14] text-[#fff5f5]/[.17] *:w-full *:h-full p-[10px] lg:p-[13px] icon ${isUnStakeAmountConfirmed && isTermsAgreed
                  ? "!bg-green/[.14] !text-green"
                  : ""
                  } `}
              >
                {delegateStepsIcon.confirm}
              </div>
            </div>
            <div className="pr-[50px] laptop:pr-[130px]">
              <h5
                className={`text-xs laptop:text-sm font-medium leading-3 laptop:leading-4 -tracking-03 mb-3 lg:mb-[14px] capitalize ${isTermsAgreed && isUnStakeAmountConfirmed
                  ? "!text-green"
                  : "!text-dim/30"
                  }`}
              >
                Step 02
              </h5>
              <p
                className={`text-xs laptop:text-sm font-normal leading-3 laptop:leading-4 -tracking-04 capitalize text-dim/30 whitespace-nowrap ${isTermsAgreed && isUnStakeAmountConfirmed
                  ? "!text-dim"
                  : "!text-dim/30"
                  }`}
              >
                {pathname?.includes("claim") ? "Confirmation" : "Review and Confirm Unstake"}
              </p>
            </div>
          </li>
        </ul>
      )}
    </div>
  );
}
